import { CommonActionsMenu } from '@ecosystem/newron-client-lib';
import { actions, elements } from '@ecosystem/newron-design-system';
import React, { cloneElement } from 'react';

import { iconMap } from '../../components/dataviz.toggle';
import { ExportButton, ExportButtonProps } from '../../export/export.button';
import { ComponentHeaderActionType } from '../../page/types';
import { DataVizConfig, DataVizType } from '../../types';
import { MultiKpiCollectionButton } from '../multiKpi/MultiKpiCollectionButton';
import { MultiKpiCollectionButtonProps } from '../multiKpi/types';

const { Menu } = actions;
const { Icon } = elements;

interface MobileOverflowMenuProps {
  isLoading: boolean;
  isAiEnabled: boolean;
  canExportDataSet: boolean;
  canEditKpis: boolean;
  canToggleDataViz: boolean;
  dataOptions?: DataVizConfig[];
  handleEditKpi?: () => void;
  runGenAI?: () => void;
  handleDataVizChange?: (value: DataVizType) => void;
  selectedDataViz?: DataVizType;
  multiKpiCollectionButtonProps?: MultiKpiCollectionButtonProps;
  exportButtonProps?: ExportButtonProps;
}

export const MobileOverflowMenu = ({
  isLoading,
  isAiEnabled,
  dataOptions,
  canExportDataSet,
  canEditKpis,
  canToggleDataViz,
  handleEditKpi,
  runGenAI,
  handleDataVizChange,
  selectedDataViz,
  multiKpiCollectionButtonProps,
  exportButtonProps,
}: MobileOverflowMenuProps) => {
  return (
    <CommonActionsMenu isDisabled={isLoading}>
      {isAiEnabled && (
        <Menu.Item onSelect={runGenAI} testId="smart-insights-menu-item">
          <Icon>
            <Icon.icons.AIGradient />
          </Icon>
          Smart Insights
        </Menu.Item>
      )}
      <MultiKpiCollectionButton {...multiKpiCollectionButtonProps} actionType={ComponentHeaderActionType.MenuItem} />
      {canExportDataSet && <ExportButton {...exportButtonProps} actionType={ComponentHeaderActionType.MenuItem} />}
      {canEditKpis && (
        <Menu.Item onSelect={handleEditKpi} testId="edit-kpi-menu-item">
          <Icon>
            <Icon.icons.Option />
          </Icon>
          Select
        </Menu.Item>
      )}
      {canToggleDataViz && (
        <>
          <Menu.Separator />
          {dataOptions.map(opt => {
            return (
              <Menu.Item
                onSelect={() => handleDataVizChange(opt.type)}
                testId={`data-viz-${opt.type}-menu-item`}
                key={opt.type}
              >
                <Icon>{cloneElement(iconMap[opt.type])}</Icon>
                {opt.name}
                {opt.type === selectedDataViz && (
                  <Icon>
                    <Icon.icons.Check />
                  </Icon>
                )}
              </Menu.Item>
            );
          })}
        </>
      )}
    </CommonActionsMenu>
  );
};
